import React from 'react';
import { WtUi } from 'wt-ui';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../../components/ErrorBoundary';
import Disclaimer from '../../components/Disclaimer';

import Header from '../Header';
import Search from '../Search';

// we need to initialize our i18n module
// eslint-disable-next-line no-unused-vars
import i18n from '../../translations/i18n';
import newrelic from './newrelic';
import heap from './heap';

newrelic.init();
heap.init();
heap.track('LoadSmartFAQ');

const App = () => {
  // initialize language from sitecore vars
  const { i18n: _i18n } = useTranslation();
  const siteCoreLang = (window.smartFaq && window.smartFaq.isoCode) || 'en-GB';
  _i18n.changeLanguage(siteCoreLang);

  return (
    <WtUi>
      <ErrorBoundary>
        <Header />
        <Search />
        <Disclaimer />
      </ErrorBoundary>
    </WtUi>
  );
};

export default App;
